import { CategoryCardModel } from '@stories/Elements/Cards/CategoryCard/CategoryCard';
import { DocumentCardProps } from '@stories/Elements/Cards/DocumentCard/DocumentCard';

export enum SystemLogo {
  M12 = 'M12',
  M18 = 'M18',
  MXFuel = 'MXFuel',
  RedLithium = 'RedLithium',
  Packout = 'Packout',
  OneKey = 'OneKey',
}

export enum DropdownType {
  DirectUrl = 'DirectUrl',
  Product = 'Product',
  System = 'System',
  Trade = 'Trade',
}

export type LinkItemModel = {
  text: string;
  url: string;
  type?: 'store-locator';
  target?: '_blank' | '_self';
};

export type NavigationItemModel = {
  type: DropdownType;
  /**
   * The ID should accurately represent the navigation level and item index. Slash represents a new level. Number represents the index of the item in the current level.
   *
   * For example, the following IDs are valid:
   *
   * ---------------------------------------------------------------------------------------------------------------
   *
   * (Level 1 & Index 1) -- id: '1'
   *
   * (Level 1 & Index 1 / Level 2 & Index 1) -- id: '1/1'
   *
   * (Level 1 & Index 1 / Level 2 & Index 1 / Level 3 & Index 1) -- id: '1/1/1'
   *
   * (Level 1 & Index 1 / Level 2 & Index 1 / Level 3 & Index 1 / with Level 4 & Index 1) -- id: '1/1/1/1'
   *
   * ---------------------------------------------------------------------------------------------------------------
   *
   * (Level 1 & Index 2 / Level 2 & Index 1) -- id: '2/1'
   *
   * ---------------------------------------------------------------------------------------------------------------
   *
   * (Level 1 & Index 5 / Level 2 & Index 3 / Level 3 & Index 1) -- id: '5/3/1'
   *
   * ---------------------------------------------------------------------------------------------------------------
   *
   * etc...
   *  */
  id: string;
  title?: string;
  text: string;
  url?: string;
  target?: '_blank' | '_self';
  isNew?: boolean;
  systemLogo?: SystemLogo;
  children?: NavigationItemModel[];
};

export interface SearchCategoryModel {
  displayName: string;
  value: string;
}

export type HeaderProps = BaseProps & {
  algoliaEnabled: boolean;
  algoliaDocumentsSearchEnabled: boolean;
  algoliaQuerySuggestionsEnabled: boolean;
  links: LinkItemModel[];
  navigation: NavigationItemModel[];
  productsVariant?: 'A' | 'B';
  helpfulLinks: KenticoLink[];
  popularProducts: ProductViewModel[];
  popularCategories: CategoryCardModel[];
  popularSearchTerms: string[] | null;
  searchCategories: SearchCategoryModel[] | null;
  featuredDocuments: DocumentCardProps[] | null;
  searchTips: string[] | null;
  translations: Record<string, string>;
  algoliaEnvironmentPrefix: string | null;
  searchDebounceMilliseconds: number;
  articleNumberSearchDebounceMilliseconds: number;
  minimumSearchCharacters: number;
};
